export default "__VITE_ASSET__BC9QWeNT__"